import { Button, HStack, useDisclosure } from "@chakra-ui/react";
import { useFlags } from "flagsmith/react";
import React from "react";
import { RiFilter3Line } from "react-icons/ri";
import { useSearchParams } from "react-router-dom";
import {
  countAppliedFilters,
  verifyIfFiltersAreApplied,
} from "../formFilters/utils";

type ChildrenProps = {
  isFilterOpen: boolean;
  onFilterToggle: () => void;
};
export const FormListViewWithFilter = (props: {
  searchInput: React.ReactElement;
  children: (
    childrenProps: ChildrenProps
  ) => React.ReactElement[] | React.ReactElement;
}) => {
  const flags = useFlags(["filter-drawer"]);
  const filterDrawerEnabled = flags["filter-drawer"].enabled;
  const { isOpen, onToggle, onOpen } = useDisclosure();
  const [searchParams] = useSearchParams();
  const appliedFiltersCount = countAppliedFilters(searchParams);

  React.useEffect(() => {
    if (!filterDrawerEnabled && verifyIfFiltersAreApplied(searchParams)) {
      onOpen();
    }
  }, [filterDrawerEnabled, searchParams, onOpen]);

  const buttonStyle =
    appliedFiltersCount > 0
      ? { variant: "outlineActivated", colorScheme: "primary" }
      : { variant: "outline", colorScheme: "gray" };

  return (
    <>
      <HStack py={6}>
        {props.searchInput}
        <Button
          {...buttonStyle}
          leftIcon={<RiFilter3Line />}
          onClick={onToggle}
        >
          Filter{appliedFiltersCount > 0 && `: ${appliedFiltersCount}`}
        </Button>
      </HStack>
      {props.children({ isFilterOpen: isOpen, onFilterToggle: onToggle })}
    </>
  );
};
